var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "background", title: "Background" } },
    [
      _c("template", { slot: "copy" }, [
        _c("p", [
          _vm._v("\n      The\n      "),
          _c("em", [_vm._v("Company")]),
          _vm._v("\n      develops\n      "),
          _c("strong", [_vm._v("Font Awesome Free")]),
          _vm._v(
            ", a set of icons, related computer software, and other material published at\n      "
          ),
          _c(
            "a",
            { attrs: { href: "https://github.com/FortAwesome/Font-Awesome" } },
            [_vm._v("github.com/FortAwesome/Font-Awesome")]
          ),
          _vm._v("\n      and\n      "),
          _c("a", { attrs: { href: "https://fontawesome.com" } }, [
            _vm._v("fontawesome.com"),
          ]),
          _vm._v(". This license is for "),
          _c("strong", [_vm._v("Font Awesome Pro")]),
          _vm._v(", a suite of additional\n      "),
          _c("strong", [_vm._v("Pro Icons")]),
          _vm._v("\n      and\n      "),
          _c("strong", [_vm._v("Pro Software")]),
          _vm._v(":\n    "),
        ]),
        _vm._v(" "),
        _c(
          "ol",
          {
            staticClass: "fa-ul",
            staticStyle: {
              "--fa-li-width": "4em",
              "--margin-bottom": "var(--spacing-2xl)",
              "--margin-top": "var(--spacing-2xl)",
            },
          },
          [
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa1 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v("Pro Icon Packs")]),
              _vm._v(
                "\n        of Pro Icons not available in Font Awesome Free, and variants of Font Awesome Free icons in different styles\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa2 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v("Duotone Icons")]),
              _vm._v(
                ", Pro Icons that are variants of Font Awesome Free and Font Awesome Pro icons in two colors, rather than one\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa3 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v("Design Plugins")]),
              _vm._v(
                ", Pro Software that makes using Font Awesome Free and Font Awesome Pro in graphics editing applications easier\n      "
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "margin-bottom-md" }, [
              _c(
                "span",
                {
                  staticClass: "fa-li",
                  staticStyle: { color: "var(--fa-gravy)" },
                },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.parent.$v6.regular.fa4 },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("strong", [_vm._v("Icon Subsetters")]),
              _vm._v(
                ", Pro Software for preparing files that contain subsets of Font Awesome Free and Font Awesome Pro icons that are more\n        efficient to Embed\n      "
              ),
            ]),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }